import React, { useState } from 'react';
import { S } from './RenameReportFileButton.styles';
import { useRenameReportFile } from '../../../../../../traits/api/backgroundControls/useRenameReportFile';

type Props = {
  backgroundControlFileId: string;
  fileName: string | undefined | null;
};

export const RenameReportFileButton: React.FC<Props> = ({
  backgroundControlFileId,
  fileName,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(fileName ?? '');
  const { mutateAsync: renameReportFile, isLoading } = useRenameReportFile();

  const startEditing = () => {
    setValue(fileName ?? '');
    setIsEditing(true);
  };

  const cancelEditing = () => {
    setIsEditing(false);
    setValue(fileName ?? '');
  };

  const save = async () => {
    if (!value.trim()) {
      return;
    }

    await renameReportFile({ backgroundControlFileId, fileName: value.trim() });
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <S.Row>
        <S.Input
          autoFocus
          value={value}
          onChange={(ev) => setValue(ev.target.value)}
        />
        <S.IconButton
          type="button"
          onClick={save}
          disabled={isLoading}
          aria-label="Spara filnamn"
        >
          <S.Icon src="CheckCircle" width={18} height={18} />
        </S.IconButton>
        <S.IconButton type="button" onClick={cancelEditing} aria-label="Avbryt">
          <S.Icon src="Close" width={18} height={18} />
        </S.IconButton>
      </S.Row>
    );
  }

  return (
    <S.Row>
      <S.FileNameText>{fileName || 'Inget filnamn angivet'}</S.FileNameText>
      <S.IconButton type="button" onClick={startEditing} aria-label="Byt filnamn">
        <S.Icon src="Pen" width={16} height={16} color="secondary" />
      </S.IconButton>
    </S.Row>
  );
};
